import { useMutation } from '@tanstack/react-query';

import { importFromText } from '../../../api/ai';

interface useImportFromTextParams {
  insertionOrder: number;
  quizId: number;
  workspaceId?: string;
  workspaceQuizId?: string;
}

export function useImportFromText({
  quizId,
  workspaceId,
  workspaceQuizId,
  insertionOrder,
}: {
  insertionOrder: number;
  quizId: number;
  workspaceId?: string;
  workspaceQuizId?: string;
}) {
  return useMutation({
    mutationFn: ({ textQuestions }: { textQuestions: string }) =>
      importFromText({
        quizId: quizId,
        workspaceId: workspaceId,
        textQuestions: textQuestions,
        insertionOrder: insertionOrder,
        workspaceQuizId: workspaceQuizId,
      }),
  });
}
